import script from "./ConnectFlowSurveyFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowSurveyFormPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__